import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const WorkflowsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/workflows" */
    'routes/Workflows/WorkflowsRoute'
  )
));

const UpdateWorkflowRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/update-workflow" */
    'routes/Workflows/UpdateWorkflowRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/analytics" */
    'routes/Workflows/AnalyticsRoute'
  )
));

const MembersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/members" */
    'routes/Workflows/MembersRoute'
  )
));

const LogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/logs" */
    'routes/Workflows/LogsRoute'
  )
));

const ConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/conversions" */
    'routes/Workflows/ConversionsRoute'
  )
));

const ExclusionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/exclusions" */
    'routes/Workflows/ExclusionsRoute'
  )
));

const PlaybooksRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/workflows/playbooks" */
    'routes/Workflows/PlaybooksRoute'
  )
));


const getWorkflowsRoutes = () => {
  return [
    {path: paths.getPathWorkflows(), component: WorkflowsRoute},
    {path: paths.getPathAddWorkflow(), component: UpdateWorkflowRoute},
    {path: paths.getPathEditWorkflow(":workflowId"), component: UpdateWorkflowRoute},
    {path: paths.getPathCreateWorkflowFromPlaybook(":playbookId"), component: UpdateWorkflowRoute},
    {path: paths.getPathReplicateWorkflow(":workflowId"), render: (props) => <UpdateWorkflowRoute {...props} isReplicate={true} />},

    {path: paths.getPathWorkflowAnalytics(":workflowId"), component: AnalyticsRoute},
    {path: paths.getPathWorkflowMembers(":workflowId"), component: MembersRoute},
    {path: paths.getPathWorkflowLogs(":workflowId"), component: LogsRoute},
    {path: paths.getPathWorkflowConversions(":workflowId"), component: ConversionsRoute},
    {path: paths.getPathWorkflowExclusions(":workflowId"), component: ExclusionsRoute},
    {path: paths.getPathWorkflowPlaybooks(), component: PlaybooksRoute},
  ]
}



export { getWorkflowsRoutes };
